import { RmsAccountDetailsComponentContainer } from '@/ui/features/accounts/components/RmsAccountDetailsComponentContainer';
import { useSlideout } from '@/ui/hooks';
import { CredentialingContextProvider } from '@juvare/credentialing/ui/providers';
import React from 'react';

export const CredentialingProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { selectedPersonId, menuItems, handlePersonIdSelect, handlePersonIdReset } = useSlideout({ clearIdOnReset: true });

    return (
        <CredentialingContextProvider
            personId={selectedPersonId}
            personDetailsComponent={(props) => (
                <RmsAccountDetailsComponentContainer accountId={props.accountId} onClose={handlePersonIdReset} menuItems={menuItems} />
            )}
            slideoutMenuItems={menuItems}
            onPersonSelect={handlePersonIdSelect}
            onPersonReset={handlePersonIdReset}
        >
            {children}
        </CredentialingContextProvider>
    );
};
